module.exports = "<form>\n  <input type=\"text\" placeholder=\"Enter name to save\" #beatName required>\n  <button class=\"save-btn\" type=\"button\" (click)=\"saveBeat(beatName.value); beatName.value=''\">Save</button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/save-beat/save-beat.component.html
// module id = ../../../../../src/app/save-beat/save-beat.component.html
// module chunks = main